export default (hit, isInit) => {
  return `
  <a href="${hit.path}" class="w-full card-people" ${isInit ? 'js-scroll-animations-target style="opacity: 0"' : ''}>
    <div class="card-people__img relative">
      <img class="object-fit-image rounded-bottom-right" src="https://res.cloudinary.com/dl8lvr6ag/image/upload/c_fill,g_face,f_auto,q_auto,w_240,h_240/${hit.picture.singleMedia.publicId}" alt="${hit.title}" />
        
      ${hit.hasVideo
      ? `<div class="card-people__video-icon">
            <svg width="23" height="23" class="icon--white">
              <use href="#icon-play" xlink:href="#icon-play" />
            </svg>
        </div>`
      : ''}
    </div>
    <div class="card-people__inner text-white text-center">
      <div>
        <p class="font-cursive text-48 xl:text-56 mb-5 leading-none">${hit.firstName}</p>

        <p class="cta mb-6">
            ${hit.job ? hit.job : ''}

            ${hit.tag.length > 0
              ? `<span class="font-medium block mt-1">${hit.tag[0]}</span>`
              : ''
            }
        </p>

        ${hit.slices !== ''
        ? `<p class="font-title card-people__quote">
          « ${hit.slices} » 
          </p>`
        : ''}
      </div>

      <span class="cta cta--icon text-mint-green mt-4">
        ${hit.hasVideo ? config.trads['portrait.see_video'] : config.trads['portrait.see']}
        <svg class="icon--mint-green" width="12" height="9">
          <use href="#icon-arrow-right" xlink:href="#icon-arrow-right" />
        </svg>
      </span>
    </div>
  </a>
  `
}
